module.exports = __webpack_public_path__ + "rosacea_5_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/rosacea_5_before.jpg
// module id = 986
// module chunks = 0